import axios from "axios";
import CustomHplFormService from "./CustomHplFormService";
import CustomForumLecternSeriesService from "./CustomForumLecternSeriesService";

const postAccessories = (
  billOfMaterials,
  customHPLFormData,
  selectedOptions
) => {
  //const env = _tempGetEnvironment();
  // const wecoApiUrl = _getWecoUrl(env);

  const wecoApiUrl = `/ignitionapi/ProductService/UpdateSAPAccessories`;
  const matwa = _getBomMatwa(billOfMaterials);
  const matwaCustom = _getCustomForumBomMatwa(billOfMaterials);
  // BOM accessories
  const accessories = _filterNonAccessoriesAndThirdPartyProducts(
    billOfMaterials
  )
    .reduce(_checkForPositionArray, [])
    .map(acc => _accessoryToRequestItem(acc, matwa));

  // accessories/custom hpl items
  const customHplAccessories = CustomHplFormService.getcustomHPLFormItems(
    matwa,
    customHPLFormData
  );

  // accessories/custom section 2 - forum Lectern series
  const customLecternAccessories = CustomForumLecternSeriesService.getCustomForumLecternItems(
    matwaCustom,
    selectedOptions
  );

  const areThereCustomHplAccessories = customHplAccessories.length > 0;
  const areThereCustomLecternAccessories = customLecternAccessories?.length > 0;
  // combining bom accessories and custom hpl items if they exist
  let allAccessories = areThereCustomHplAccessories
    ? [...accessories, ...customHplAccessories]
    : accessories;

  if (areThereCustomLecternAccessories) {
    customLecternAccessories.forEach(Element => {
      allAccessories.push(Element);
    });
  }

  // this skips the weco call if there are no accessories or there is no IsProductVariant
  if (0 === allAccessories.length || null === matwa) {
    return Promise.resolve(null);
  }

  const data = {
    ZVCMATCATALOGTABLEUPDATE: [...allAccessories]
  };

  return axios(wecoApiUrl, {
    method: "post",
    data: data
  });
};

// helpers

const _filterNonAccessoriesAndThirdPartyProducts = bomArray =>
  bomArray.filter(bomItem => {
    return bomItem.IsAccessory === true || isThirdPartyProducts(bomItem);
  });

const isThirdPartyProducts = product => true === product.isThirdPartyProduct;

const _checkForPositionArray = (acc, accessory) => {
  // only if position is an Array,
  if (Array.isArray(accessory.Position)) {
    // takes the items position array
    const positions = accessory.Position;
    // takes each position and creates an individual accesory for each position item
    positions.forEach(item =>
      acc.push({ ...accessory, Position: item, Quantity: 1 })
    );
    return acc;
  }
  return [...acc, accessory];
};

// looks for the bomItem that is the product variant and assigns the ProductName to the matwa
const _getBomMatwa = bomArray => {
  if (bomArray && bomArray.length > 0) {
    return bomArray.reduce((acc, bomItem) => {
      if (true === bomItem.IsProductVariant) {
        acc = bomItem.PartName;
      }
      return acc;
    }, null);
  } else {
    return null;
  }
};
const _accessoryToRequestItem = (accessory, matwa) => {
  return {
    matwa,
    amatnr: accessory.Value,
    aquantity: accessory.Quantity ?? accessory.DefaultQuantity,
    aposition: accessory.Position,
    adescription: accessory.AccessoryDescription,
    atype: accessory.AccessoryType
  };
};

// custom getBOMMATWA

const _getCustomForumBomMatwa = bomArray => {
  if (bomArray && bomArray.length > 0) {
    return bomArray.reduce((acc, bomItem) => {
      if (
        true === bomItem.IsProductVariant &&
        bomItem.PartName.includes("FMP")
      ) {
        acc.push({
          PartName: bomItem.PartName,
          TranslationCode: bomItem.TranslationCode
        });
      }
      return acc;
    }, []);
  } else {
    return null;
  }
};

// // local is pointed to the same url as dev and devfeature by default
// function _getWecoUrl(env) {
//   if ("dev" === env || "devfeature" === env || "local" === env) {
//     return "http://sapdevecc.legrandav.com:8010/zzapi/zzvcdata?sap-client=100";
//   }
//   if ("qafeature" === env) {
//     return "http://sapqe1.legrandav.com:8000/zzapi/zzvcdata?sap-client=100";
//   }
//   if ("qa" === env) {
//     return "http://sapwecoqa.legrandav.com/zzapi/zzvcdata?sap-client=100";
//   }
//   if (
//     "prod" === env ||
//     "prodcontent" === env ||
//     "stg" === env ||
//     "stgcontent" === env
//   ) {
//     return "https://nextpt.legrandav.com/zzapi/zzvcdata?sap-client=100";
//   }
// }

// // TODO: replace _tempGetEnvironment
// // gets the environment based on url,
// function _tempGetEnvironment() {
//   let url;
//   if (window.location.origin) {
//     url = window.location.origin;
//   } else {
//     url = window.location.href;
//   }

//   url = url.toLowerCase();

//   if (url.includes("content.legrandav.com")) {
//     return "prodcontent";
//   }
//   if (url.includes("www.legrandav.com")) {
//     return "prod";
//   }
//   if (url.includes("dev.legrandav.com")) {
//     return "dev";
//   }
//   if (url.includes("devfeature.legrandav.com")) {
//     return "devfeature";
//   }
//   if (url.includes("qa.legrandav.com")) {
//     return "qa";
//   }
//   if (url.includes("qafeature.legrandav.com")) {
//     return "qafeature";
//   }
//   if (url.includes("stg.legrandav.com")) {
//     return "stg";
//   }
//   if (url.includes("stgcontent.legrandav.com")) {
//     return "stgcontent";
//   }
//   // default env
//   return "local";
// }

export default {
  postAccessories
};
